function FollowMeUtils() {}

/**
 * Creates a hash based on a string
 * Based on https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 * @param {string} string
 * @static
 */
FollowMeUtils.hashString = function (string) {
  var hash = 0;
  var character;
  if (string.length === 0) return hash;

  for (var i = 0; i < string.length; i++) {
    character = string.charCodeAt(i);
    hash = ((hash<<5)-hash) + character;
    hash &= hash; // Convert to 32bit integer
  }

  return hash;
};

module.exports = FollowMeUtils;
